export default __webpack_public_path__ + "images/MT.d12e37f.png";